/**
 * Utility functions for working with bitmap values.
 */

/**
 * Checks if a specific bit is set in a bitmap.
 *
 * @param bitmap - The bitmap value to check
 * @param position - The zero-indexed bit position to check
 * @returns true if the bit at the given position is set, false otherwise
 *
 * @example
 * // Check if bit 0 is set in bitmap 5 (binary: 101)
 * isBitSet(5, 0) // returns true
 * isBitSet(5, 1) // returns false
 * isBitSet(5, 2) // returns true
 */
export const isBitSet = (bitmap: number, position: number): boolean => {
  // check for negative position
  if (position < 0) {
    return false;
  }

  // eslint-disable-next-line no-bitwise
  return (bitmap & (1 << position)) !== 0;
};
